import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-devsecops',
  imports: [CommonModule, RouterLink],
  templateUrl: './devsecops.html',
  styleUrl: './devsecops.css'
})
export class Devsecops {
  features = [
    {
      title: 'Security Scanning Automation',
      description: 'Automated SAST, DAST, and SCA scanning integrated into CI/CD pipelines to catch vulnerabilities early.',
      icon: 'scanning'
    },
    {
      title: 'Container Security',
      description: 'Image scanning, runtime protection, and compliance enforcement for containerized workloads.',
      icon: 'container'
    },
    {
      title: 'Secrets Management',
      description: 'Secure credential storage and rotation with HashiCorp Vault, AWS Secrets Manager, and Azure Key Vault.',
      icon: 'secrets'
    },
    {
      title: 'Compliance Automation',
      description: 'Automated compliance checking for PCI DSS, HIPAA, SOC 2, ISO 27001, and GDPR requirements.',
      icon: 'compliance'
    },
    {
      title: 'Infrastructure Security',
      description: 'Network segmentation, security groups, WAF configuration, and DDoS protection.',
      icon: 'infrastructure'
    },
    {
      title: 'Incident Response',
      description: 'Automated threat detection, security alerts, and incident response playbooks.',
      icon: 'incident'
    }
  ];

  process = [
    { step: 1, title: 'Security Assessment', description: 'Evaluate current security posture and identify vulnerabilities across the SDLC.' },
    { step: 2, title: 'Security Integration', description: 'Integrate security tools into development and deployment pipelines.' },
    { step: 3, title: 'Automation & Remediation', description: 'Automate security scans, compliance checks, and vulnerability remediation.' },
    { step: 4, title: 'Monitor & Improve', description: 'Continuous monitoring with regular security assessments and improvements.' }
  ];

  caseStudy = {
    client: 'SecureBank Financial',
    industry: 'Financial Services',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=500&fit=crop',
    challenge: 'SecureBank faced regulatory pressure for PCI DSS compliance and had slow manual security reviews delaying releases. They discovered critical vulnerabilities in production multiple times per quarter.',
    solution: 'We implemented comprehensive DevSecOps with automated security scanning, secrets management, and compliance automation. Security became part of every pipeline stage.',
    results: [
      { metric: '98%', description: 'Vulnerabilities Caught Pre-Production' },
      { metric: 'Zero', description: 'Critical Vulnerabilities in Production' },
      { metric: '85%', description: 'Faster Security Review Process' },
      { metric: '100%', description: 'PCI DSS Compliance Automation' }
    ]
  };

  testimonial = {
    quote: 'HoneyKode transformed security from a bottleneck into an enabler. We now catch vulnerabilities before they reach production, and compliance audits that used to take weeks now happen continuously. Our regulators are impressed with our automated controls.',
    author: 'David Chen',
    role: 'CISO',
    company: 'SecureBank Financial',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
  };

  tools = [
    { name: 'Snyk', category: 'Vulnerability Scanning' },
    { name: 'SonarQube', category: 'Code Quality & Security' },
    { name: 'HashiCorp Vault', category: 'Secrets Management' },
    { name: 'Aqua Security', category: 'Container Security' },
    { name: 'Prisma Cloud', category: 'Cloud Security' },
    { name: 'OWASP ZAP', category: 'DAST' },
    { name: 'Trivy', category: 'Container Scanning' },
    { name: 'AWS Security Hub', category: 'Security Posture' }
  ];
}
